class DrawTextInnerShadow {
    constructor(element, options) {
        this.element = element;
        this.width = options.width || 200;
        this.height = options.height|| 200;
        this.rgbColor = options.rgbColor || '#gray';
        this.font = options.font || '';
        this.text = options.text || 'inner shadow';
        this.textPosition = options.textPosition || {x: 0, y: 0};
        this.shadowDarkenPercent = options.shadowDarkenPercent || -80;
        this.blur = options.shadowWidth || 1;
        this.blurPosition = options.shadowPosition || {x: 0, y: 1};
    }

    draw() {
        let svg, title, g1;
        svg = this.cesvg('svg', this.element);
        svg.setAttribute('width', this.width);
        svg.setAttribute('height', this.height);
        svg.setAttribute('viewBox', `0 0 ${this.width} ${this.height}`);

        title = this.cesvg('title', svg);
        title.textContent = this.text;

        g1 = this.cesvg('g', svg);
        g1.style.font = this.font;

        let defs;
        defs = this.cesvg('defs', g1);

        let mask, maskId, maskText;
        mask = this.cesvg('mask', defs);
        maskId = this.newID();
        mask.id = maskId;
        maskText = this.cesvg('text', mask);
        maskText.textContent = this.text;
        maskText.setAttribute('fill', 'white');
        maskText.setAttribute('x', this.textPosition.x);
        maskText.setAttribute('y', this.textPosition.y);

        let filter, filterId, feGaussianBlur, feOffset;
        filter = this.cesvg('filter', defs);
        filterId = this.newID();
        filter.id = filterId;
        feGaussianBlur = this.cesvg('feGaussianBlur', filter);
        feGaussianBlur.setAttribute('in', 'SourceGraphic');
        feGaussianBlur.setAttribute('stdDeviation', this.blur);
        feGaussianBlur.setAttribute('result', 'blur');
        feOffset = this.cesvg('feOffset', filter);
        feOffset.setAttribute('in', 'blur');
        feOffset.setAttribute('dx', this.blurPosition.x);
        feOffset.setAttribute('dy', this.blurPosition.y);

        let g2, rect, text;
        g2 = this.cesvg('g', g1);
        g2.setAttribute('mask', `url(#${maskId})`);

        rect = this.cesvg('rect', g2);
        rect.setAttribute('x', 0);
        rect.setAttribute('y', 0);
        rect.setAttribute('width', this.width);
        rect.setAttribute('height', this.height);
        rect.style.fill = this.shadeColor(this.rgbColor, this.shadowDarkenPercent);

        text = this.cesvg('text', g2);
        text.textContent = this.text;
        text.style.fill = this.rgbColor;
        text.style.filter = `url(#${filterId})`;
        text.setAttribute('x', this.textPosition.x);
        text.setAttribute('y', this.textPosition.y);
    }

    cesvg(tag, targetElement) {
        let svgElement = document.createElementNS('http://www.w3.org/2000/svg', tag);
        targetElement.appendChild(svgElement);
        return svgElement;
    }

    shadeColor(color, percent) {

        var R = parseInt(color.substring(1,3),16);
        var G = parseInt(color.substring(3,5),16);
        var B = parseInt(color.substring(5,7),16);

        R = parseInt(R * (100 + percent) / 100);
        G = parseInt(G * (100 + percent) / 100);
        B = parseInt(B * (100 + percent) / 100);

        R = (R<255)?R:255;
        G = (G<255)?G:255;
        B = (B<255)?B:255;

        var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
        var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
        var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));

        return "#"+RR+GG+BB;
    }

    newID() {
        return Math.random().toString(36).substr(2, 16);
    }
}

export default DrawTextInnerShadow;